import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export type KeyCommunityMembersProps = {
  id: number;
  search?: string;
};

export const keyCommunityMembers: BaseKeyFunction<KeyCommunityMembersProps> = ({
  id,
  search,
}) => ["communities-members", id.toString(), search ?? ""];
